import { INFERRED_PROJECT_PAGE, INFERRED_PROJECT_PATH } from '@townsquare/config/routes';
import { createGlobalRoute, createSiteRoute } from '@townsquare/router/create-route';
import type { GlobalHomePageRoute, SiteHomePageRoute } from '@townsquare/router/route-types';

export const inferredProjectRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: INFERRED_PROJECT_PAGE,
	path: INFERRED_PROJECT_PATH,
	nav4Layout: 'expanded',
	featureGating: {
		gates: ['home_inferred_project_entity_page'],
		behavior: { type: 'enabled' },
	},
});

export const inferredProjectInboundRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: `${INFERRED_PROJECT_PAGE}-inbound`,
	path: INFERRED_PROJECT_PATH,
	nav4Layout: 'expanded',
	featureGating: {
		gates: ['home_inferred_project_entity_page'],
		behavior: { type: 'enabled' },
	},
});
